export type RosterMediaKind = "main" | "gallery" | "video" | "club_logo"

export type RosterLinks = {
  transfermarkt?: string | null
  instagram?: string | null
  youtube?: string | null
  tiktok?: string | null
  other?: string[] | null
}

export type RosterClubEntry = {
  club: string
  fromDate?: string | null
  toDate?: string | null
  note?: string | null
  logoMediaId?: string | null
  logoUrl?: string | null
  /** At most one club per player; none = free agent / no club */
  isCurrent?: boolean
}

export type RosterMedia = {
  id: string
  rosterPlayerId: string
  kind: RosterMediaKind
  contentType?: string | null
  sizeBytes?: number | null
  originalFilename?: string | null
  externalUrl?: string | null
  url?: string | null
  sortOrder: number
  createdAt: string
  updatedAt: string
}

export type RosterPlayerSummary = {
  id: string
  slug: string
  name: string
  position?: string | null
  positions?: string[]
  currentClub?: string | null
  mainPhotoUrl?: string | null
  isPublished: boolean
  isPasswordProtected?: boolean
  shareToken?: string | null
  sortOrder: number
}

export type RosterPlayerDetail = {
  id: string
  slug: string
  name: string
  position?: string | null
  positions: string[]
  currentClub?: string | null
  dateOfBirth?: string | null
  placeOfBirth?: string | null
  nationalities: string[]
  heightCm?: number | null
  weightKg?: number | null
  preferredFoot?: string | null
  contractUntil?: string | null
  marketValue?: string | null
  clubHistory: RosterClubEntry[]
  highlights: string[]
  bio?: string | null
  links: RosterLinks
  isPublished: boolean
  isPasswordProtected?: boolean
  shareToken?: string | null
  sortOrder: number
  mainPhotoMediaId?: string | null
  mainPhotoUrl?: string | null
  media: RosterMedia[]
  createdAt: string
  updatedAt: string
}

export type RosterPlayerCreate = {
  name: string
  slug?: string
  positions?: string[]
  currentClub?: string | null
  dateOfBirth?: string | null
  placeOfBirth?: string | null
  nationalities?: string[]
  heightCm?: number | null
  weightKg?: number | null
  preferredFoot?: string | null
  contractUntil?: string | null
  marketValue?: string | null
  clubHistory?: RosterClubEntry[]
  highlights?: string[]
  bio?: string | null
  links?: RosterLinks
  isPublished?: boolean
  sortOrder?: number
  accessPassword?: string
  clearAccessPassword?: boolean
}

export type RosterPlayerUpdate = Partial<RosterPlayerCreate> & {
  mainPhotoMediaId?: string | null
}

export class RosterLockedError extends Error {
  constructor() {
    super("This profile is protected")
    this.name = "RosterLockedError"
  }
}

export function isRosterLockedError(error: unknown): boolean {
  return (
    error instanceof RosterLockedError ||
    (error instanceof Error && error.name === "RosterLockedError")
  )
}
